import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.982 13.47c1.296 5.044-1.742 10.181-6.785 11.477-5.043 1.296-10.181-1.742-11.477-6.785",
      stroke: "#fff",
      strokeWidth: 1.44
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.864 13.104a3.144 3.144 0 1 0-6.16-1.258 3.144 3.144 0 0 0 6.16 1.258Z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "m22.024 14.01 5.877-1.034",
      stroke: "#fff",
      strokeWidth: 1.44
    })]
  }));
};
export default SvgComponent;